import axios from 'axios';


// eslint-disable-next-line unicorn/prefer-export-from
export { axios };

export default {
  install(app /* , options */) {
    app.config.globalProperties.$axios = axios;
  },
};
